import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { Link as MuiLink, Stack } from "@mui/material";
import { LabelValueForText } from "components/ui/atoms/LabelValue";
import { Link } from "react-router-dom";
import { getCommons } from "./fieldConverterHelpers";

export const FileLink = ({ value }) => {
  return (
    <MuiLink
      component={Link}
      underline="hover"
      color="inherit"
      to={value?.url}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        spacing={1}
      >
        <InsertDriveFileIcon fontSize="small" />
        File
      </Stack>
    </MuiLink>
  );
};

export const FileCell = ({ value }) => {
  return value && <FileLink value={value} />;
};

export const FileFieldView = ({ field, value }) => {
  return (
    <LabelValueForText
      label={field.label}
      value={<FileLink value={value} />}
      sx={{ display: field.hidden ? "none" : "inherit" }}
      isMissing={!value}
    />
  );
};

export const fileFieldConverter = ({ field }) => {
  return {
    ...getCommons({ field }),
    type: "string",
    renderCell: FileCell,
    disableClickEvent: true,
  };
};
